import { Component, OnInit, EventEmitter, Output, Input } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { debounceTime } from 'rxjs/operators';

@Component({
	selector: "app-telefono",
	templateUrl: "./telefono.component.html",
	styleUrls: ["./telefono.component.css"],
})
export class TelefonoComponent implements OnInit {
	@Output() onChange = new EventEmitter<object>();
	@Input() telefonos : any

	telefonoFormulario: FormGroup;formControlName

	constructor(private formBuilder: FormBuilder) {
		console.log(this.telefonos)
		this.crearFormulario();
	}

	ngOnInit(): void {
		this.telefonoFormulario.valueChanges.pipe(
			debounceTime(1500)
			).subscribe(values => {
			console.log(values)
			const emitValues = {
				DatosContacto_TelefonoFijo: +values.DatosContacto_TelefonoFijo,
				DatosContacto_TelefonoCelular: +values.DatosContacto_TelefonoCelular
			}
			this.onChange.emit(emitValues)
		})
	}

	crearFormulario() {
		this.telefonoFormulario = this.formBuilder.group({
			DatosContacto_TelefonoFijo: ["",Validators.compose([Validators.required,Validators.pattern(/^-?(0|[1-9]\d*)?$/), Validators.maxLength(10)])],
			DatosContacto_TelefonoCelular: ["",Validators.required,Validators.compose([Validators.pattern(/^-?(0|[1-9]\d*)?$/), Validators.maxLength(10)])],
		});
	}

}
